import React from 'react';
import { NextPage } from 'next';
import Layout from '../../components/layout';
import GenericContainer from '../../components/@container/generic-container';
import Link from '../../components/link';

const ChildSafetyInformationPage: NextPage = () => (
  <Layout title="Volvo Child Safety Information">
    <GenericContainer
      title="Volvo Child Safety Information"
      breadcrumb={{ url: '/resources', text: 'Back to Resources' }}
    >
      <div className="content">
        <p>
          Volvo has a long and extensive child safety history. We believe in
          protecting our smallest passengers by providing the same level of
          safety we provide to adults.
        </p>
        <p>
          Beginning in 1960s, with the development of the first child safety
          seat, to the recently introduced dual level integrated booster
          cushion, our commitment to child safety is unprecedented.
        </p>
        <p>
          Child Safety is an important issue to government agencies as well. The
          U.S. National Highway Traffic Safety Administration (NHTSA) designates
          one week per year as Child Passengers (CPS) Week. The primary goal of
          this campaign is to ensure more children use booster seats and child
          safety seats, and that they are seated in the proper place - NOT in
          the front seat.
        </p>
        <p>
          Child Safety products are designed to suit the age and weight of the
          child. The importance of seating children safely in the vehicle, in
          proper child restraints, cannot be stressed enough.
        </p>
        <p>
          <strong>
            Attached are two short, important child safety publications prepared
            by Volvo:
          </strong>
        </p>
        <ul>
          <li>
            <strong className="light">
              <Link href="https://cdn.volvotechinfo.com/uploads/61f066756cde5c31446a3451/UsingLATCH-equippedChildSafetySeats.pdf">
                <a>LATCH ONTO CHILD SAFETY WITH VOLVO</a>
              </Link>
            </strong>{' '}
            talks about the proper use of Lower Anchors and Tethers for
            Children.
          </li>
          <li>
            <strong className="light">
              <Link href="https://cdn.volvotechinfo.com/uploads/61f066516cde5c31446a3450/SeatingChildrenSafelyinaVolvo.pdf">
                <a>SEATING CHILDREN SAFELY IN A VOLVO</a>
              </Link>
            </strong>{' '}
            addresses common types of child safety seats and when to use which.
          </li>
        </ul>
        <p>The publications cover these important subjects:</p>
        <ul>
          <li>Volvo child safety recommendations</li>
          <li>Most common seat types</li>
          <li>Securing a child restraint using seatbelts</li>
          <li>When to look forward</li>
          <li>Securing a booster cushion using seatbelts</li>
          <li>Facts about how Volvo makes child car safety more dependable</li>
          <li>Volvo makes child safety easier</li>
          <li>How to position child seats</li>
          <li>Using the LATCH lower child seat anchors</li>
          <li>Using the LATCH top tether anchors</li>
        </ul>
        <p>
          Volvo encourages you to read and learn from this information, and to
          share it in your home, in your workplace, with your drivers, and with
          civic organizations.
        </p>
      </div>
      {/* language=CSS */}
      <style jsx>{`
        .content {
          font-family: 'Volvo Novum', sans-serif;
        }

        .content strong {
          font-weight: 500;
        }

        .content strong.light {
          font-weight: 300;
        }
      `}</style>
    </GenericContainer>
  </Layout>
);

export default ChildSafetyInformationPage;
